/**
 * Aracı kargo entegrasyonu için tüm sistemde benzersiz barkod üretir.
 *
 * İç biçim: `<tenant_kodu (3 hane, 0'la doldurulmuş)>` + `<order_number (8 hane, 0'la doldurulmuş)>`,
 * ARDINDAN baştaki sıfırlar KIRPILIR — çünkü FEST/Deposel barkodu sayısal işler ve kaydı sıfırsız
 * saklar; panelde/sorguda görünen biçim budur. Bu yüzden ürettiğimiz kanonik barkod da sıfırsızdır
 * (DB'de saklanan, Excel MÜŞ. BARKOD'da görünen ve API'ye gönderilen değer aynı olsun).
 * Örnek: `tenantCode=1`, `orderNumber="12694"` → iç "00100012694" → `"100012694"`.
 *
 * `tenant_code` (tenant başına benzersiz) + `order_number` (tenant içinde benzersiz) kombinasyonu
 * sabit 3+8 genişlikte üretildiği için, baştaki sıfırları kırpmak birebir (injektif) kalır —
 * farklı (tenant, sipariş) çiftleri aynı değere düşmez.
 */
export function buildCargoBarcode(tenantCode: number, orderNumber: string | number): string {
  if (!Number.isInteger(tenantCode) || tenantCode <= 0) {
    throw new Error(`Geçersiz tenant kodu: ${tenantCode}`)
  }
  const digits = String(orderNumber).replace(/\D/g, '')
  if (!digits) {
    throw new Error(`Geçersiz sipariş numarası: ${orderNumber}`)
  }
  const tenantPart = String(tenantCode).padStart(3, '0')
  const orderPart = digits.padStart(8, '0')
  return stripLeadingZeros(tenantPart + orderPart)
}

/**
 * FEST barkodu SAYISAL işler: gönderimde `00100012659` yollasak da kaydı `100012659`
 * (baştaki sıfırlar kırpılmış) olarak saklar ve yalnız bu biçimle sorgulanır. Bu yüzden
 * takip/sorgu isteklerinde ve yanıt eşleşmesinde barkod bu fonksiyonla normalize edilir.
 * Not: 11 haneli sabit genişlikteki barkodlar için baştaki sıfırları kırpmak birebir (injektif)
 * bir dönüşümdür — farklı barkodlar aynı değere düşmez, benzersizlik korunur.
 */
export function stripLeadingZeros(barcode: string | number): string {
  return String(barcode).replace(/^0+/, '') || '0'
}
